<script setup>
const props = defineProps({
	datetime: {
		type: String,
		default: '',
	},
	category: {
		type: String,
		default: '',
	},
})

const appStore = useAppStore()
const dayjs = inject('dayjs')
const publishedAt = computed(() => date => {
	return dayjs(date).locale(appStore.i18n).format("D MMM 'YY")
})
</script>

<template>
	<small class="opacity-50">
		<time :datetime="datetime">{{ publishedAt(datetime) }}</time>
		<i
			v-if="datetime && category"
			class="str-diamond mx-1"
		/>
		<span>{{ category }}</span>
	</small>
</template>

<!-- <small class="opacity-50">
						{{ publishedAt(article.published_at) }}
						<i class="str-diamond mx-1" />
						{{ article.main_category[0].name }}
					</small> -->
